<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <!-- Card header -->
        <card-header :title="$router.currentRoute.meta.title" >
          <!-- <router-link v-if="!serverError" :to="{ name: `${routePrefix}.edit`,params:{id} }"  class="btn btn-primary btn-sm"  v-can:edit="permissionPrefix">
            <i class="fa fa-edit"></i>
          </router-link> -->
        </card-header>
        <!-- Card body -->
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <div v-if="serverError" class="alert alert-danger">
                  <strong>{{ $t('labels.error') }} : </strong> {{ serverError }}
                </div>
              </div>
            </div>
            <div class="row" v-if="!serverError">
              <files-image v-model="image" :options="{ id: 'image', disabled: true }"/>
            </div>
            <div class="row" v-if="!serverError">
              <input-text v-model="name" :options="{ id: 'name', label: 'name', disabled: true }"/>
              <select-supplier-types v-model="type" :options="{ id: 'supplier_type', label: 'type', disabled: true }"/>
              <select-countries v-model="country_id" :options="{ id: 'country_id', label: 'country', disabled: true }"/>
              <select-platforms v-if="needPlatformID()" v-model="owner_id" :options="{ id: 'platform_id', label: 'platform', disabled: true }"/>
              <select-platform-brands v-if="needBrands()" v-model="brandIds" :platform_id="owner_id" :options="{ id: 'brands', label: 'brands', multiple: true, disabled: true }"/>
              <input-checkbox v-model="wallet_enabled" :options="{ id: 'wallet_enabled', transPrefix: `${transPrefix}.fields`, label: 'wallet_enabled', disabled: true, containerClass: 'col-12 col-md-6 mt-5' }"/>
              <input-checkbox v-model="full_time_drivers" :options="{ id: 'full_time_drivers', transPrefix: `${transPrefix}.fields`, label: 'full_time_drivers', disabled: true, containerClass: 'col-12 col-md-6 mt-5' }"/>
            </div>
          </div>
          <!-- Card footer -->
          <div class="card-footer">
            <div class="row">
              <div class="col text-right">
                <attach-captain-action :itemID="id" v-can:add="captainsPermissionPrefix"/>
                <de-attach-captain-action :itemID="id" v-can:add="captainsPermissionPrefix"/>
                <router-link :to="{ name: `${routePrefix}.index`}"  class="btn btn-neutral btn-sm">
                  <i class="fa fa-arrow-left"></i>
                </router-link>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { SUPPLIERS_SHOW as CRUD_ACTION_SHOW } from 'actions/suppliers';
  import attachCaptainAction from "./actions/attach_captain";
  import deAttachCaptainAction from "./actions/de_attach_captain";
  const CRUD_CODE="suppliers";
  export default {
    name: "SupplierShow",
    components:{
      attachCaptainAction,
      deAttachCaptainAction,
    },
    data(){
      return {
        routePrefix: CRUD_CODE,
        transPrefix: CRUD_CODE,
        permissionPrefix: CRUD_CODE,
        captainsPermissionPrefix: 'supplier_captains',
        id:this.$router.currentRoute.params.id,
        type: '',
        name: '',
        wallet_enabled : false,
        full_time_drivers: false,
        country_id: "",
        owner_id: "",
        brandIds: [],
        serverError: '',
        image:{
          file:'',
          thumbnail:'',
        },
      }
    },
    mounted() {
      this.getItem();
    },
    methods: {
      getItem(){
        this.$store.dispatch(CRUD_ACTION_SHOW,{
          id: this.id,
        }).then(response=>{
          this.type=response.data.type;
          this.owner_id=response.data.ownerId;
          this.name=response.data.name;
          this.wallet_enabled = response.data.usesWallet;
          this.full_time_drivers = response.data.fullTimeDrivers;
          this.country_id=response.data.country?response.data.country.id:null;
          this.image.thumbnail=response.data.image?response.data.image.url:'';
          this.brandIds=response.data.brands?.map(brand => "" + brand.id);
        }).catch(error => {
          this.loading = false;
          this.serverError='';

          if(error.response){
            let responseData=error.response.data;

            if(responseData.errors){
              this.fieldErrors=responseData.errors;
            }else{
              this.serverError = 'Invalid Request.'
            }
          }else{
            this.serverError = this.$i18n.t("messages.no_internet_connection");
          }

          if(this.fieldErrors.error){
            this.serverError = this.fieldErrors.error;
          }
        });
      },
      needPlatformID(){
        return ["CAPTAINS_PLATFORM_DEDICATED","CAPTAINS_BRAND_DEDICATED"].includes(this.type);
      },
      needBrands() {
        return ["CAPTAINS_BRAND_DEDICATED"].includes(this.type);
      }
    }
  };
</script>
